<template>
  <div class="">
    <p class="top-header">
      Engines
      <v-btn
        @click="getManufacturers()"
        small
        class="text-capitalize float-right"
        color="primary"
        dark
      >
        <v-icon class="mr-2" small>mdi-refresh</v-icon>
        {{ $t("Reload") }}
      </v-btn>
    </p>
    <hr class="mb-3" />
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>
    <v-row>
      <v-col cols="12" sm="2">
        <v-btn
          @click="goToCreate()"
          width="200"
          small
          class="text-capitalize top-btn-driver"
          color="primary"
          dark
          v-if="hasPermissions(createBtnPerms)"
          >+ Create Engine Manufacturer
        </v-btn>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn
          @click="goToCreateModel()"
          width="200"
          small
          class="text-capitalize top-btn-driver"
          color="primary"
          dark
          v-if="hasPermissions(createBtnPerms)"
          >+ Create Engine Model
        </v-btn>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          @keydown.enter="getManufacturers()"
          v-model="qSearch"
          solo
          dense
          flat
          :label="$t('SearchProducts') + '...'"
          :prepend-inner-icon="'mdi-account-search'"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="manufacturers"
      :options.sync="options"
      :server-items-length="totalManufacturers"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
      show-expand
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="_id"
      :key="tableExpandKey"
      @click:row="expandRow"
    >
      <template v-slot:[`item.edit`]="{ item }">
        <v-btn
          icon
          small
          @click="goToManufacturer(item)"
          :disabled="!hasPermissions(editPencilPerms)"
        >
          <img width="20px" height="20px" src="/icons/edit.svg" />
        </v-btn>
      </template>
      <template
        v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }"
      >
        <v-icon>
          {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </template>
      <template v-slot:expanded-item="{ headers }">
        <td :colspan="headers.length" class="pa-5">
          <v-row>
            <v-col>
              <h3 class="mb-2">
                Models
              </h3>
            </v-col>
            <v-col class="text-end">
              <span
                ><b>Total models: ( {{ models.length }} )</b></span
              >
            </v-col>
          </v-row>
          <v-simple-table
            fixed-header
            class="elevation-5"
            :height="models.length > 6 ? 350 : ''"
            ref="table"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left font-size-10">
                    Name
                  </th>
                  <th class="text-left font-size-10">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody v-if="!loadingModels">
                <tr v-for="model of models" :key="model._id">
                  <td>
                    {{ model.name }}
                  </td>
                  <td>
                    <v-btn
                      @click="goToEditModel(model)"
                      small
                      class="text-capitalize top-btn-driver"
                      color="primary"
                      dark
                    >
                      Edit
                    </v-btn>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <h4 class="ml-5 mt-2 mb-2">
                    Loading models...
                  </h4>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { Permission } from "@/utils/permissions";
import { permissionMixin } from "@/utils/mixins";
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceProduct from "../../api/apiProductsService";
import RestResourceLog from "../../api/apiLogsService";
import { axiosBase } from "../../api/axios-base";
import * as axios from "axios";
import RestResourceBrand from "../../api/apiBrandService";
import RestResourceModel from "../../api/apiModelService";
import RestResourceManufacturer from "../../api/apiManufacturerService";
import RestResourceEngineModel from "../../api/apiEngineModelService";

export default {
  name: "BrandsList",
  mixins: [permissionMixin],
  data() {
    return {
      serverUrl: process.env.VUE_APP_BASE_URL,
      staticUrl: process.env.VUE_APP_BASE_STATIC,
      noColorId: process.env.VUE_APP_NO_COLOR_ID,
      loadingTable: false,
      manufacturers: [],
      models: [],
      options: {},
      loadingModels: false,
      tableExpandKey: 0,
      footerProps: vdataTable.footerProps,
      totalManufacturers: 0,
      qSearch: "",
      errorAlert: false,
      errorMsg: "",
      logsToShow: [],
      updating: false,
      singleExpand: true,
      expanded: [],
      sending: false,
      uploadImage: {},
      selectedProduct: "",
      colorDialog: false,
      updateLogDialogNoColor: false,
      colors: [],
      colorsImages: {},
      incrementQuantity: "",
      decrementQuantity: "",
      selectedCode: "",
      selectedPrice: "",
      selectedLog: {
        _id: "",
        files: ""
      },
      updateLogDialogIncrement: false,
      updateLogDialogDecrement: false,
      updateLogDialog: false,
      loadingProducts: false,
      filterParams: {
        name: null,
        value: null,
        supplier: null,
        category: null,
        price: null
      },
      headers: [
        {
          text: this.$t("Edit"),
          align: "start",
          sortable: false,
          width: 100,
          value: "edit"
        },
        {
          text: this.$t("Name"),
          width: 225,
          align: "start",
          sortable: false,
          value: "name"
        },
        {
          text: "Show Models",
          value: "data-table-expand",
          width: 120,
          align: "end"
        }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getManufacturers();
      },
      deep: true
    }
  },
  computed: {
    editPencilPerms() {
      return [Permission.EDIT_PRODUCT];
    },
    createBtnPerms() {
      return [Permission.ADD_PRODUCT];
    }
  },
  methods: {
    expandRow(item) {
      // this.getLogsToShow(item);
      this.expanded = item === this.expanded[0] ? [] : [item];
      this.getModels(item);
    },
    openDialogColor(item) {
      this.selectedProduct = Object.assign({}, item);
      let colors = this.selectedProduct.logs
        .filter(l => l.color !== null)
        .map(l => l.color.name);
      colors = colors.filter((color, index) => {
        return colors.indexOf(color) === index;
      });
      const uploadImage = this.uploadImage;
      colors.forEach(color => {
        uploadImage[color] = [];
      });
      this.selectedProduct.logs.forEach(log => {
        if (log.color) {
          this.colorsImages[log.color.name] = {
            pictureUrls: log.pictureUrls,
            productId: log.productId,
            colorId: log.color._id
          };
          console.log(log);
        }
      });
      this.colors = colors;
      this.colorDialog = true;
    },
    closeColorDialog() {
      setTimeout(() => {
        this.selectedProduct = Object.assign({}, this.options);
        this.$refs.form.reset();
      }, 500);
      this.colorDialog = false;
    },
    async updatePictures() {
      this.sending = true;
      for (const image in this.uploadImage) {
        const logs = this.selectedProduct.logs;
        const log = logs.find(l => l.color.name === image);
        const body = {
          _id: log._id,
          files: this.uploadImage[image]
        };
        await RestResourceLog.prototype.postLog(body);
      }
      this.sending = false;
      this.closeColorDialog();
      this.uploadImage = {};
      this.getProducts();
    },
    forceFileDownload(response, code) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", code + ".png"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(url, code) {
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer"
      })
        .then(response => {
          this.forceFileDownload(response, code);
        })
        .catch(() => console.log("error occured"));
    },
    getManufacturers() {
      if (this.qSearch.length >= 1 && this.qSearch.length <= 2) {
        this.errorAlert = true;
        this.errorMsg = "The search must have 3 or more characters.";
        return;
      }
      this.loadingTable = true;
      RestResourceManufacturer.prototype
        .getManufacturers(this.getParams())
        .then(response => {
          if (response.status === ResponseStatus.OK) {
            this.totalManufacturers = response.data.total;
            this.manufacturers = response.data.data;
          }
        })
        .catch(error => {
          this.errorMsg = error.response.data.message;
          this.errorAlert = true;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    editInformation(product) {
      this.$router.push({
        name: "productId",
        params: { id: product._id }
      });
    },
    addColorOrSize(product) {
      this.$router.push({
        name: "product_color_size",
        params: { id: product._id }
      });
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      let params = {
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      };
      params = { ...params, ...this.filterParams };
      return params;
    },
    getModels(manufacturer) {
      this.loadingModels = true;
      RestResourceEngineModel.prototype
        .getModelsByManufacturer(manufacturer._id, { skip: 0, limit: -1 })
        .then(response => {
          this.models = response.data.data;
        })
        .catch(error => {
          this.errorMsg = error.response.data.message;
          this.errorAlert = true;
        })
        .finally(() => {
          this.loadingModels = false;
        });
    },
    openDialogIncrementLog(item) {
      this.selectedLog = Object.assign({}, item);
      this.updateLogDialogIncrement = true;
    },
    openDialogDecrementLog(item) {
      this.selectedLog = Object.assign({}, item);
      this.updateLogDialogDecrement = true;
    },
    openDialogUpdateLog(item) {
      this.selectedLog = Object.assign({}, item);
      this.updateLogDialog = true;
    },
    closeUpdateLogDialog() {
      setTimeout(() => {
        this.selectedLog = Object.assign({}, {});
        this.$refs.form.reset();
      }, 500);
      this.updateLogDialog = false;
    },
    closeUpdateLogDialogIncrement() {
      setTimeout(() => {
        this.selectedLog = Object.assign({}, {});
        this.$refs.form.reset();
      }, 500);
      this.updateLogDialogIncrement = false;
    },
    closeUpdateLogDialogDecrement() {
      setTimeout(() => {
        this.selectedLog = Object.assign({}, {});
        this.$refs.form.reset();
      }, 500);
      this.updateLogDialogDecrement = false;
    },
    async updateProduct() {
      this.loadingProducts = false;
      if (!this.$refs.form.validate()) return;
      try {
        let body = { _id: this.selectedLog._id };
        if (this.incrementQuantity)
          body = { ...body, quantity: `+${this.incrementQuantity}` };
        if (this.decrementQuantity)
          body = { ...body, quantity: `-${this.decrementQuantity}` };
        if (this.selectedLog.files)
          body = { ...body, files: this.selectedLog.files };
        await RestResourceLog.prototype.postLog(body);
        this.closeUpdateLogDialog();
        this.closeUpdateLogDialogNoColor();
        this.closeUpdateLogDialogIncrement();
        this.closeUpdateLogDialogDecrement();
        this.quantity = "";
      } catch (error) {
        this.errorAlert = true;
        this.errorMsg = error.response.data.message;
        this.closeUpdateLogDialog();
        this.closeUpdateLogDialogIncrement();
        this.closeUpdateLogDialogDecrement();
      } finally {
        this.getProducts();
        this.loadingProducts = false;
      }
    },
    downloadBarCode(log, selectedCode, selectedPrice) {
      let code;
      if (log.color && !log.size) {
        code = selectedCode + log.color.code + "00";
      } else if (!log.color && log.size) {
        code = selectedCode + "00" + log.size.code;
      } else if (!log.color && !log.size) {
        code = selectedCode + "0000";
      } else {
        code = selectedCode + log.color.code + log.size.code;
      }
      this.downloadWithAxios(
        `https://pdf.yogoms.com/label/png?price=${selectedPrice}&number=${code}`,
        code
      );
    },
    async enableProduct(product, enable) {
      await RestResourceProduct.prototype
        .enableProduct(product._id, enable)
        .then(() => {
          this.getProducts();
        })
        .catch(error => {
          this.errorAlert = true;
          this.errorMsg = error.response.data.message;
        });
    },
    loadImage(url, _id) {
      let result;
      RestResourceLog.prototype
        .getImage(url, _id)
        .then(res => {
          result = res.data;
        })
        .catch(error => {
          console.log(error);
        });
      return result;
    },
    async deleteImages(log) {
      if (
        await this.$root.$confirm(
          "",
          "Are you sure you want to delete all pictures?"
        )
      ) {
        RestResourceLog.prototype
          .deleteImages(log._id)
          .then(() => {
            this.getProducts();
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMsg = error.response.data.message;
          });
      }
    },
    openDialogUpdateLogNoColor(item) {
      this.selectedLog = Object.assign({}, item);
      this.updateLogDialogNoColor = true;
    },
    closeUpdateLogDialogNoColor() {
      setTimeout(() => {
        this.selectedLog = Object.assign({}, {});
        this.$refs.form.reset();
      }, 500);
      this.updateLogDialogNoColor = false;
    },
    async deleteProduct(product) {
      if (
        await this.$root.$confirm(
          "",
          "Are you sure you want to delete the product?"
        )
      ) {
        RestResourceProduct.prototype
          .deleteProduct(product._id)
          .then(() => {
            this.getProducts();
          })
          .catch(error => {
            this.errorAlert = true;
            this.errorMsg = error.response.data.message;
          });
      }
    },
    goToEditModel(model) {
      this.$router.push({
        name: "engineModelId",
        params: { id: model._id }
      });
    },
    goToManufacturer(manufacturer) {
      this.$router.push({
        name: "manufacturerId",
        params: { id: manufacturer._id }
      });
    },
    goToCreate() {
      this.$router.push({
        name: "new_manufacturer"
      });
    },
    goToCreateModel() {
      this.$router.push({
        name: "new_engine_model"
      });
    }
  }
};
</script>

<style>
.admin-filter-input >>> .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 1rem !important;
  font-weight: 200;
}

.admin-filter-input >>> .v-select__slot .v-input__append-inner {
  margin-top: 5px !important;
}

.admin-filter-input >>> .v-select__selections {
  font-size: 12px;
}
</style>
